import PropTypes from 'prop-types'
import React from 'react'
import { TagBox } from '../../molecules/TagBox'

const passwordChangeText = {
  true: { label: 'NO', tagType: 'warning' },
  false: { label: 'SI', tagType: 'success' }
}

const UserPasswordReset = ({ user }) => {
  const needsChange = !!user.required_password_change
  const status = passwordChangeText[needsChange]
  return (
    <div className="flex flex-col items-start gap-1">
      <TagBox className="text-xs" label={status.label} tagType={status.tagType} />
    </div>
  )
}

UserPasswordReset.propTypes = {
  user: PropTypes.object
}

export default UserPasswordReset
